define(function () {
	'use strict';

	/**
	 * Context enum
	 */
	return {
		SERVICE_PROVIDER : 'Service Provider',
		CLOUD_IDENTITIES_MANAGEMENT : 'Cloud Identities Management',
		CLOUD_IDENTITIES_API_REQUEST : 'Cloud Identities API Request'
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/model/Context.js
// module id = 32
// module chunks = 3